import { MatxSuspense } from "components";
import { selectSettings } from "store/features/settingsSlice";
import { useSelector,  } from "react-redux";
import { VenueLogLayouts } from "./index";

export default function MatxLayout(props) {
  const settings = useSelector(selectSettings);
  const Layout = VenueLogLayouts[settings.activeLayout];

  return (
    <MatxSuspense>
      <Layout {...props} />
    </MatxSuspense>
  );
}
